// extracted by mini-css-extract-plugin
module.exports = {"HeaderName":"Header_HeaderName__2oNMU","HeaderTitle":"Header_HeaderTitle__1y0Kg"};